import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const PASSWORD_PATTERN = /^password$/i;
const COOKIE_NAME = 'hn_access';

const hasSessionCookie = () => document.cookie.split('; ').some(c => c.startsWith(`${COOKIE_NAME}=`));

const hasPasswordParam = () => new URLSearchParams(window.location.search).get('shared') === 'true';

const setSessionCookie = () => {
	document.cookie = `${COOKIE_NAME}=1; path=/; SameSite=Strict`;
};

const showContent = (gate, contentWrap) => {
	gate.style.display = 'none';
	setTimeout(() => {
		contentWrap.style.display = 'block';
		contentWrap.setAttribute('aria-hidden', 'false');
		ScrollTrigger.refresh();
	}, 0);
};

const initGSAPIntroGate = () => {

	// hide global nav to prevent FOUC on any pages
	gsap.set(["#global-nav"], { opacity: 1 });

	const gate = document.querySelector('.intro-gate');
	if (!gate) return;
	const contentWrap = document.querySelector('.intro-gate__content');

	if (hasSessionCookie() || hasPasswordParam()) {
		if (hasPasswordParam()) setSessionCookie();
		showContent(gate, contentWrap);
	}
	else {
		gsap.to(gate, { opacity: 1, duration: 0.5, ease: 'power2.inOut' });
		gsap.set(["#global-nav", ".page-accordion", "footer"], { opacity: 0, display: 'none' });
	}

	const hero = gate.querySelector('.intro-gate__hero');
	const heroElements = hero.children;
	const passwordPanel = gate.querySelector('.intro-gate__password');
	const passwordPanelElements = passwordPanel.children;
	const form = gate.querySelector('.intro-gate__form');
	const input = gate.querySelector('.intro-gate__input');
	const errorMsg = gate.querySelector('.intro-gate__error');

	gsap.set(passwordPanelElements, { opacity: 0, scale: 0.99 });
	gsap.set(contentWrap, { display: 'none' });

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: gate,
			start: 'top top',
			end: '+=50%',
			pin: true,
			scrub: 2,
		},
	});

	tl.to(heroElements, {
		opacity: 0,
		duration: 0.4,
		y: -5,
		scale: 0.99,
		stagger: 0.1,
		ease: 'power2.inOut'
	}, 0)
		.to(passwordPanelElements, {
			opacity: 1,
			duration: 0.6,
			scale: 1,
			stagger: 0.1,
			ease: 'power2.inOut'
		}, 0.4);


	const fadeInContent = () => {
		tl.scrollTrigger.kill();
		gate.style.display = 'none';
		contentWrap.style.display = 'block';
		contentWrap.setAttribute('aria-hidden', 'false');
		gsap.to(["#global-nav", ".page-accordion", "footer"], { opacity: 1, display: 'block' });
		ScrollTrigger.refresh();
		window.scrollTo({ top: 0, behavior: 'instant' });
		gsap.fromTo(contentWrap,
			{
				opacity: 0,
				y: 40
			},
			{
				opacity: 1,
				y: 0,
				duration: 0.5,
				ease: 'power2.out',
				onComplete: () => {
					gsap.set(contentWrap, { clearProps: 'all' });
				}
			}
		);
	}

	const handleSubmit = (e) => {
		e.preventDefault();
		const value = input.value.trim();
		if (PASSWORD_PATTERN.test(value)) {
			errorMsg.hidden = true;
			setSessionCookie();
			gsap.to(gate, {
				y: -10,
				opacity: 0,
				duration: 0.6,
				ease: 'power2.inOut',
				onComplete: () => {
					fadeInContent();
				}
			});
		} else {
			errorMsg.hidden = false;
			gsap.fromTo(form, { x: -8 }, { x: 0, duration: 0.4, ease: 'elastic.out(1, 0.3)' });
			input.focus();
		}
	};

	form.addEventListener('submit', handleSubmit);
};

export { initGSAPIntroGate };
